var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailedConnectionsEmptyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 6C39.076 6 44 11 44 18C44 32 29 40 24 43C19 40 4 32 4 18C4 11 9 6 15 6C18.72 6 22 8 24 10C26 8 29.28 6 33 6Z",
    fill: "#D4D3D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedConnectionsEmptyIcon);
export default __webpack_public_path__ + "static/media/failed_connections_empty_icon.9fcc0eb87be55c3071e1d83925876904.svg";
export { ForwardRef as ReactComponent };